export const KpoWithdrawnReason = {
  Mistake: "Pomyłka",
  Malfunction: "Awaria środka transportu",
  Cancellation: "Rezygnacja",
}

export const KPO_WITHDRAWN_REASON = {
  MISTAKE: "Mistake",
  MALFUNCTION: "Malfunction",
  CANCELLATION: "Cancellation",
}
